import api from '@/lib/api';
import { authLogger } from '@/utils/logger';

export interface PasswordResetTokenResponse {
  token: string;
  email: string;
  expiryDate: string;
  valid: boolean;
  message: string;
}

export interface ApiMessageResponse {
  message: string;
}

export const passwordResetService = {
  // Solicitar reset de senha
  async requestPasswordReset(email: string): Promise<ApiMessageResponse> {
    try {
      authLogger.log('Solicitando reset de senha para:', email);
      
      // Enviar o email como objeto JSON com headers explícitos
      const response = await api.post<ApiMessageResponse>('/auth/forgot-password', 
        { email },
        {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }
      );
      
      authLogger.log('Resposta da solicitação de reset:', response.data);
      return response.data;
    } catch (error) {
      authLogger.error('Erro ao solicitar reset de senha:', error);
      throw error;
    }
  },

  // Validar token de reset
  async validateToken(token: string): Promise<PasswordResetTokenResponse> {
    try {
      authLogger.log('Validando token de reset:', token);
      
      const response = await api.get<PasswordResetTokenResponse>(`/auth/validate-reset-token/${token}`);
      
      authLogger.log('Token validado:', response.data);
      return response.data;
    } catch (error) {
      authLogger.error('Erro ao validar token:', error);
      throw error;
    }
  },

  // Redefinir senha
  async resetPassword(token: string, newPassword: string): Promise<ApiMessageResponse> {
    try {
      authLogger.log('Redefinindo senha com token');
      
      const response = await api.post<ApiMessageResponse>('/auth/reset-password', {
        token,
        newPassword
      });
      
      authLogger.log('Senha redefinida com sucesso');
      return response.data;
    } catch (error) {
      authLogger.error('Erro ao redefinir senha:', error);
      throw error;
    }
  }
};